import request from '@/utils/httpRequest'

export default class BrandService {
    queryById(id) {
        return request({
            url: '/shye/base/brand/queryById',
            method: 'get',
            params: {id: id}
        });
    }

    startFlow (params) {
        return request({
            url: '/shye/base/brand/startFlow',
            method: 'post',
            data: params
        })
    }
    customers(params) {
        return request({
            url: '/shye/base/brand/customers',
            method: 'get',
            params: params
        });
    }
}
